import React, { useEffect, useState } from 'react'
import Select from 'react-select';

import { history } from '../../../../_helpers/history';
import { useDispatch } from 'react-redux'
import { alertActions } from '../../../../_actions/alert.actions'
import { rolesService } from '../../../../_services/roles.service'
import { Alert, Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap'
import RolesOptions from '../../../../_components/Options/RolesOptions';

export default function ArchiveModal({ id, count, show, handleClose }) {
  const dispatch = useDispatch(null)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [userCount, setUserCount] = useState()
  const [roleOptions, setRoleOptions] = useState([])
  const [roleSelected, setRoleSelected] = useState(null)

  useEffect(() => {
    setUserCount(count);
  }, [count])

  useEffect(() => {
    if (show) {
      rolesService.retrieveRoles()
        .then(roles => {
          const options = []
          roles.data.data.forEach(role => {
            if (role.id !== parseInt(id) && !role.deletedAt) {
              options.push({ label: role.name, value: role })
            } 
          })
          setRoleOptions(options)
        })
        .catch(() => {
          setError('Could not retrieve roles at this time. Please try again.')
        })
    } 
  }, [show, dispatch, id])

  const handleCloseModal = () => {
    setError('')
    setLoading(false)
    setTimeout(() => {
      handleClose()
    }, 100);
  }
  
  const handleArchive = () => {
    setLoading(true)
    dispatch(alertActions.clear())

    rolesService.archiveRole(id, roleSelected)
      .then(() => {
        history.push('/account/roles')

        dispatch(alertActions.success('Role archived!'));
      })
      .catch(() => {
        setError('Could not archive role at this time. Please try again.');
      })
      .then(() => {
        setLoading(false)
      })
  }

  const role = roleOptions.find((role) => {
    return role.value.id === roleSelected;
  });

  return (
    <Modal show={show} onHide={handleCloseModal} size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>Archive Role</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        { error && <Alert variant='danger'>{ error }</Alert> }
        <Row>
          <Col>
            <p>By archiving this role, you will not be able to assign this role to a user.</p>
            { userCount > 0 &&
              <>
                <p>There {userCount === 1 ? 'is' : 'are'} <b>{userCount}</b> users with this role.</p>
                <p>Please select which role you would like to move them to before archiving.</p>
                <RolesOptions
                  excludeById={parseInt(id)} 
                   handleSelected={selected => {
                    if (selected) {
                      setRoleSelected(selected.value)
                    } else {
                      setRoleSelected(null)
                    }
                  }}
                />
              </>
            }
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Row className='w-100 justify-content-end'>
          <Col xs='4'>
            <Button disabled={loading || (!role && userCount > 0)} onClick={handleArchive} block variant='success'>
              { loading ? <Spinner size='sm' animation='border' /> : 'Archive'}
            </Button>
          </Col>
          <Col xs='3'>
            <Button disabled={loading} onClick={handleCloseModal} block variant='secondary'>Cancel</Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  )
}
